import { render, staticRenderFns } from "./NewsFile.vue?vue&type=template&id=3cb35af1&scoped=true&"
import script from "./NewsFile.vue?vue&type=script&lang=js&"
export * from "./NewsFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb35af1",
  null
  
)

export default component.exports